import { http } from "@/utils/http";
export const getFQAList = (params) => {
  // 获取faq列表
  return http({
    url: `/1/faqs`,
    method: "get",
    params: params,
  });
};
export const getFAQDetail = (params) => {
  // 获取fqa详情
  return http({
    url: `/1/faqs/${params.id}`,
    method: "get",
  });
};
export const getQuestionList = (params) => {
  // 获取1:1询问列表
  return http({
    url: `/1/questions`,
    method: "get",
    params: params,
  });
};
export const addQuestion = (params) => {
  // 发文1:1询问列表
  return http({
    url: `/1/questions`,
    method: "post",
    data: params,
  });
};
export const editQuestion = (params) => {
  // 修改发文1:1询问列表
  return http({
    url: `/1/questions/${params.id}/`,
    method: "put",
    data: params,
  });
};
export const getQuestionDetail = (params) => {
  // 发文1:1询问列表详情
  return http({
    url: `/1/questions/${params.id}`,
    method: "get",
  });
};
export const commentsQuestion = (params) => {
  // 回复1:1问题
  return http({
    url: `/1/comments`,
    method: "post",
    data: params,
  });
};
export const getRule = () => {
  // 获取会员条款
  return http({
    url: `/1/terms/1`,
    method: "get",
  });
};
export const delOneForOne = (data) => {
  // 删除一对一咨询
  return http({
    url: `/1/questions/${data}/`,
    method: "PATCH",
    data: {
      status: "0",
    },
  });
};
